export default "__VITE_ASSET__CaMKC9IB__"